@if (enabled()) {
  <div class="relative">
    <button
      type="button"
      class="rounded px-8 py-4"
      aria-haspopup="menu"
      [attr.aria-expanded]="opened()"
      [attr.aria-label]="'Actions for ' + subtask().title"
      (click)="toggle()"
    >
      ⋯
    </button>
    @if (opened()) {
      <div
        role="menu"
        aria-label="Subtask actions"
        class="absolute right-0 z-10 flex flex-col rounded border border-border bg-background p-4 shadow-lg"
      >
        <button type="button" role="menuitem" class="whitespace-nowrap px-8 py-4 text-left" (click)="assign()">
          Assign
        </button>
        <button
          type="button"
          role="menuitem"
          class="whitespace-nowrap px-8 py-4 text-left"
          [disabled]="reviewDisabled()"
          (click)="requestReview()"
        >
          Request review…
        </button>
        <button type="button" role="menuitem" class="whitespace-nowrap px-8 py-4 text-left" (click)="moveToTrash()">
          Move to trash
        </button>
      </div>
    }
  </div>
}
